export const runsInBrowser = (): boolean => {
  return typeof window !== "undefined";
};

// Create a singleton instance of SafeLocalStorage
const SafeLocalStorage = {
  setItem: (key: string, value: any) => {
    runsInBrowser() && localStorage.setItem(key, JSON.stringify(value));
  },
  getItem: (key: string) => {
    if (runsInBrowser()) {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch {
        return null;
      }
    }

    return null;
  },
  removeItem: (key: string) => {
    runsInBrowser() && localStorage.removeItem(key);
  },
};

export default SafeLocalStorage; 
